import { get } from '../../http'

const path = '/api/me'

export default {
  me() {
    return get(path)
  },
  accountingCompanies() {
    return get(`${path}/accounting-companies`)
  },
}
